import { render, staticRenderFns } from "./ListResponsavelVisualizadorView.vue?vue&type=template&id=4c7164e3&"
import script from "./ListResponsavelVisualizadorView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelVisualizadorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports